import comp from "./PromptAction";
export default comp;
